import { BrowserRouter, Route, Switch } from "react-router-dom";
import "./App.css";
import AddBlood from "./components/dashboard/addBlood";
import Dashboard from "./components/dashboard/dashboard";

function App() {
  return (
    <BrowserRouter>
      <Switch>
        <Route exact path='/' component={Dashboard} />
        <Route exact path='/donate-blood' component={AddBlood} />
        {/* <Route path='/edit-client/:id' component={EditClient} /> */}
      </Switch>
    </BrowserRouter>
  );
}

export default App;
